export const REDIRECT_VERSION_PLACEHOLDER = '${VERSION}'
